// extracted by mini-css-extract-plugin
export default {"container":"PinnedDashboard_container__vxRPg","dashboard":"PinnedDashboard_dashboard__yVoWP","editButton":"PinnedDashboard_editButton__c2+4P"};